import axios from "axios";
import { store } from "../../store";
import { EInfractionType, INavigationTip } from "../types/navigationTips";
import api from "./index";

export const getNavigationTips = async (): Promise<INavigationTip[]> => {
  try {
    const response = await api.get(`/v1/infractions/info/list`);

    // Ajustando para a estrutura correta da resposta da API
    const apiTips = response.data?.result?.infractions || response.data?.data?.result?.infractions || response.data?.data?.result || [];

    const mappedTips: INavigationTip[] = apiTips.map((tip: any) => {
      return {
        id: tip.id || '',
        infractionType: tip.infractionType || EInfractionType.IT_IDLING,
        description: tip.description || '',
        text: tip.text || '',
        videoLink: tip.link || '',
      };
    });

    return mappedTips;
  } catch (error) {
    console.error('Erro ao buscar dicas de navegação:', error);
    throw error; // Re-lança o erro para que o controller possa capturar
  }
};

export const saveNavigationTip = async (
  tip: Omit<INavigationTip, 'id'>,
  file?: File
): Promise<void> => {
  try {
    const formData = new FormData();

    // Adicionar todos os campos como form fields
    formData.append('infractionType', tip.infractionType);
    formData.append('description', tip.description);
    formData.append('text', tip.text);

    // Se há um arquivo, adicionar como file
    if (file) {
      formData.append('file', file);
    }

    // Se há um link de vídeo, adicionar como form field
    if (tip.videoLink) {
      formData.append('link', tip.videoLink);
    }

    // Log para debug
    console.log('Dados sendo enviados:', {
      infractionType: tip.infractionType,
      description: tip.description,
      text: tip.text,
      videoLink: tip.videoLink,
      hasFile: !!file,
      fileName: file?.name
    });

    // Obter token do store do Redux
    const access_token = (store.getState() as any).tokenHandling?.accessToken;
    const baseURL = process.env.REACT_APP_BASE_URL || 'https://api.non-prod.latam-routing.rio.cloud';

    console.log('Token obtido:', access_token ? 'Token presente' : 'Token ausente');

    const response = await axios.post(`${baseURL}/v1/infractions/info/create`, formData, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json, text/plain, */*',
      },
    });

    console.log('Resposta da API:', response.data);
    return Promise.resolve();
  } catch (error) {
    console.error('Erro ao salvar dica de navegação:', error);
    throw error;
  }
};

export const updateNavigationTip = async (
  id: string,
  tip: INavigationTip,
  file?: File
): Promise<void> => {
  try {
    const formData = new FormData();

    // Adicionar todos os campos como form fields
    formData.append('id', tip.id);
    formData.append('infractionType', tip.infractionType);
    formData.append('description', tip.description);
    formData.append('text', tip.text);

    // Se há um arquivo, adicionar como file
    if (file) {
      formData.append('file', file);
    }

    // Se há um link de vídeo, adicionar como form field
    if (tip.videoLink) {
      formData.append('link', tip.videoLink);
    }

    // Log para debug
    console.log('Dados sendo enviados para update:', {
      id: tip.id,
      infractionType: tip.infractionType,
      description: tip.description,
      text: tip.text,
      videoLink: tip.videoLink,
      hasFile: !!file,
      fileName: file?.name
    });

    // Obter token do store do Redux
    const access_token = (store.getState() as any).tokenHandling?.accessToken;
    const baseURL = process.env.REACT_APP_BASE_URL || 'https://api.non-prod.latam-routing.rio.cloud';

    console.log('Token obtido (update):', access_token ? 'Token presente' : 'Token ausente');

    const response = await axios.post(`${baseURL}/v1/infractions/info/create`, formData, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json, text/plain, */*',
      },
    });

    console.log('Resposta da API (update):', response.data);
    return Promise.resolve();
  } catch (error) {
    console.error('Erro ao atualizar dica de navegação:', error);
    throw error;
  }
};

export const deleteNavigationTip = async (id: string): Promise<void> => {
  try {
    await api.post(`/v1/infractions/info/delete/${id}`);
  } catch (error) {
    console.error('Erro ao excluir dica de navegação:', error);
    throw error;
  }
}; 